import React, { } from 'react';
import {IProps} from './types';
import * as S from './styles';
import FontFamillyComandOption from './CommandsOptions/FontFamillyComandOption';
import FontSizeCommandOption from './CommandsOptions/FontSizeCommandOption';
import FontColorCommandOption from './CommandsOptions/FontColorComandOption';
import FontWeightCommandOption from './CommandsOptions/FontWeightCommandOption';
import FontItalicCommandOption from './CommandsOptions/FontItalicCommandOption';
import FontUnderlineCommandOption from './CommandsOptions/FontUnderlineCommandOption';
import FontAlignmentCommandOption from './CommandsOptions/FontAlignmentCommandOption';
import FontSpacingCommandOption from './CommandsOptions/FontSpacingCommandOption';
import FontUppercaseCommandOption from './CommandsOptions/FontUppercaseCommandOption';
import FontSuperscriptCommandOption from './CommandsOptions/FontSuperscriptCommandOption';
import FontSubscriptCommandOption from './CommandsOptions/FontSubscriptCommandOption';
const TextCommandBar:React.FC<IProps> = (props) => {
  
  return (
    <S.Root>
      <FontFamillyComandOption/>
      <FontSizeCommandOption/>
      <FontColorCommandOption/>
      <FontWeightCommandOption/>
      <FontItalicCommandOption/>
      <FontUnderlineCommandOption/>
      <FontUppercaseCommandOption/>
      <FontSuperscriptCommandOption/>
      <FontSubscriptCommandOption/>
      <S.Line/>
      <FontSpacingCommandOption/>
      <S.Line/>
      <FontAlignmentCommandOption/>
      <S.Line/>
    </S.Root>
  );
}

export default TextCommandBar;